<template>
  <div class="h-100">
    <div class="d-flex flex-column flex-root align-items-stretch h-100">
      <div class="page d-flex flex-row align-items-stretch flex-column-fluid">
        <div id="kt_aside" class="aside aside-dark aside-hoverable landlord-aside" data-kt-drawer="true" data-kt-drawer-name="aside"
             data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
             data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
             data-kt-drawer-toggle="#kt_aside_mobile_toggle">
          <div class="aside-logo flex-column-auto" id="kt_aside_logo">
            <router-link to="/landlord/dashboard">
              <a href="" class="aside-logo-link">
                <img alt="Logo" src="/assets/media/logos/qomerxia-logo.png" class="h-25px logo" />
                <img alt="Logo" src="/assets/media/logos/qomerxia-icon.png" class="h-30px logo-minimize" />
              </a>
            </router-link>
            <div id="kt_aside_toggle" class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
                 data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body"
                 data-kt-toggle-name="aside-minimize">
              <span class="svg-icon svg-icon-1 rotate-180">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor" />
                  <path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <landlord-menu></landlord-menu>
        </div>
        <div class="wrapper d-flex flex-column align-items-stretch flex-row-fluid" id="kt_wrapper">
          <landlord-header></landlord-header>
          <router-view></router-view>
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandlordMenu from './Layouts/partials/LandlordMenu.vue'
import LandlordHeader from './Layouts/partials/LandlordHeader.vue'
import AppFooter from '../Layouts/partials/AppFooter.vue'

export default {
    name: 'LandlordLayout',
    components: {
        LandlordMenu,
        LandlordHeader,
        AppFooter
    },
    mounted() {
        if (!this.$store.getters['landlordAuth/admin']) {
            this.$store.dispatch('landlordAuth/me')
        }
        this.$nextTick(() => {
            KTMenu.init()
            KTDrawer.init()
        })
    },
    updated() {
        this.$nextTick(() => {
            KTMenu.init()
            KTDrawer.init()
        })
    }
}
</script>
